import React,{useState} from 'react';
import './App.css';
import {InputArea} from './components/InputArea';
import TodoItem from './components/todoitem';


function App() {
  //hooks has too things varName,function to set varName
  const[items,setItems] = useState([]);

  const addItems = (inputText) => {
    setItems((prevItems)=> {
      return [...prevItems,inputText];
    })
  }


  const deleteItem = (id) => {
    setItems((prevItems) => {
      return prevItems.filter((item,index)=>{
        return index !== id;

      })
    })
  }

  return (
    <div className="container">
      <div className="heading">
        <h1>Todo list </h1>
      </div>
      <div>
      <ul>
        <InputArea onAdd={addItems} />
         {items.map((item,index)=>(
           <TodoItem key={index} id={index} text={item} onChecked={deleteItem} />
           )
         )}
      </ul>
      </div>
      </div>
  );
}

export default App;
